import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { drapcodeIcon } from '../../common/custom/icon-library';
import {
  menuItemsForCustomCssJs,
  getAppSettingBasePath,
  isAppSettingActive,
} from '../../common/utils/api_utils';

const CustomCSSJSMenu = () => {
  const { pathname } = useLocation();
  const { projectId, version } = useParams();

  const dropdownColor = menuItemsForCustomCssJs.some((item) =>
    isAppSettingActive(pathname, item.key, version, projectId),
  )
    ? 'theme-green--dropdown'
    : 'theme-primary--dropdown';

  return (
    <UncontrolledDropdown group className="ml-2">
      <DropdownToggle color={dropdownColor} title="Custom UI/UX" className="btn-md" caret>
        <i className={`wb ${drapcodeIcon('customCssJs')}`}></i> Custom UI/UX
      </DropdownToggle>
      <DropdownMenu>
        {menuItemsForCustomCssJs.map((item) => {
          const to = getAppSettingBasePath(item.key, version, projectId);
          const activeClass = isAppSettingActive(pathname, item.key, version, projectId)
            ? 'active'
            : '';
          return (
            <DropdownItem
              key={item.key}
              tag={Link}
              to={to}
              className={`theme-primary ${activeClass}`}
            >
              <i className={`wb ${drapcodeIcon(item.icon)}`}></i>&nbsp;{item.label}&nbsp;
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default CustomCSSJSMenu;
